import { JobQueue } from 'components/JobQueue';
import React from 'react';

const JobQueuePage: React.FC = () => {
  return (
    <div
      style={{
        backgroundColor: '#ffffff',
        // minHeight: '100vh',
        // padding: '24px',
      }}>
      <JobQueue />
    </div>
  );
};

export default JobQueuePage;
